/* =========================================================================
   Sparsets: Abwählen nachrechnen und das Set in den Warenkorb legen —
   auf der Set-Seite (custom-sparset-detail.liquid) und direkt von den
   Karten der Übersicht (custom-sparsets.liquid), dazu Reihen und Kopf-Video

   Rechnung wie in der Discount Function „PRESCH Sparset-Rabatt":
   Summe der gewählten Einzelpreise minus der festen Rabatte der gewählten
   Artikel — aber nur ab der Mindestzahl des Sets. Rabatte stehen in
   Shopwährung (Euro) im Markup; in anderer Währung wird mit
   Shopify.currency.rate umgerechnet und je Artikel auf Cent gerundet,
   genau wie die Function mit presentmentCurrencyRate.

   Warenkorb: Shopifys eigene Aktion (wie „Passt dazu" und das
   Versandfrei-Angebot), danach die Schublade öffnen. Ohne die Aktion:
   /cart/add.js und weiter zu /cart.
   ========================================================================= */
(() => {
  if (window.__preschSparsets) return;
  window.__preschSparsets = true;

  const kurs = Number(window.Shopify?.currency?.rate) > 0 ? Number(window.Shopify.currency.rate) : 1;
  const waehrung = window.Shopify?.currency?.active || 'EUR';
  let geld;
  try {
    geld = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: waehrung });
  } catch {
    geld = new Intl.NumberFormat('de', { style: 'currency', currency: 'EUR' });
  }
  const format = (cent) => geld.format(cent / 100);
  const umrechnen = (cent) => Math.round(cent * kurs);

  // Set-Artikel und Zusatzprodukte getrennt: Nur Set-Artikel zählen für die
  // Mindestzahl und tragen Rabatt; Zusatzprodukte kommen zum vollen Preis dazu.
  const SET_FELD = '.custom-sparset__check:not([data-zusatz])';
  const ZUSATZ_FELD = '.custom-sparset__check[data-zusatz]';

  const rechnen = (karte) => {
    const mindestens = Number(karte.dataset.mindestens) || 2;
    // :checked genügt — Ausverkauftes steht nie auf checked, das feste
    // Hauptprodukt ist checked UND disabled und muss mitgezählt werden.
    const gewaehlt = [...karte.querySelectorAll(`${SET_FELD}:checked`)];
    const pflichtFehlt = [...karte.querySelectorAll(`${SET_FELD}[data-pflicht]`)].some((f) => !f.checked);
    const zusatz = [...karte.querySelectorAll(`${ZUSATZ_FELD}:checked:not(:disabled)`)];
    // Gewerbekunden (Variante C, 12.10.2026; Modell seit 14.10.2026): data-preis =
    // Nettopreis p der Preisliste, data-gewerbe = Gewerbepreis G (custom.gewerbepreis,
    // die 5 % zieht die Function gewerbepreis ab). Einzeln zahlen sie G. Im Set
    // gilt der Set-Preis des Privatkunden netto, wenn er günstiger ist — Rechnung
    // wie gewerbeKandidaten in der Function sparset-rabatt, Cent für Cent:
    //   g = p − G, s = round(Rabatt × Kurs ÷ (1 + MwSt)), d = s − g je Set-Artikel,
    //   extra = round(max(0, d) × Σd ÷ Σmax(0, d)) wenn Σd > 0, höchstens G;
    //   Zusatzprodukte einzeln max(0, s − g), höchstens G.
    const b2bEl = karte.closest('[data-b2b-mwst]');
    const zahlt = (f) => Number(b2bEl && f.dataset.gewerbe !== undefined ? f.dataset.gewerbe : f.dataset.preis);
    const einzeln = gewaehlt.reduce((s, f) => s + zahlt(f), 0);
    const zusatzSumme = zusatz.reduce((s, f) => s + zahlt(f), 0);
    // Zusatzprodukte haben einen eigenen kleinen Rabatt — aber nur, wenn das Set gilt.
    const gueltig = gewaehlt.length >= mindestens && !pflichtFehlt;
    let rabatt = 0;
    if (gueltig && b2bEl) {
      const m = Number(b2bEl.dataset.b2bMwst);
      const diff = (f) => Math.round((Number(f.dataset.rabatt || 0) * kurs) / (1 + m)) - (Number(f.dataset.preis) - zahlt(f));
      const d = gewaehlt.map(diff);
      const summe = d.reduce((s, x) => s + x, 0);
      const positiv = d.reduce((s, x) => s + Math.max(0, x), 0);
      if (summe > 0 && positiv > 0) {
        rabatt = d.reduce((s, x, i) => s + Math.min(Math.round((Math.max(0, x) * summe) / positiv), zahlt(gewaehlt[i])), 0);
      }
      rabatt += zusatz.reduce((s, f) => s + Math.min(Math.max(0, diff(f)), zahlt(f)), 0);
    } else if (gueltig) {
      rabatt = [...gewaehlt, ...zusatz].reduce((s, f) => s + Math.min(umrechnen(Number(f.dataset.rabatt || 0)), Number(f.dataset.preis)), 0);
    }

    // Gewerbekunden, Ersparnis je Artikel (Wunsch 19.10.2026): angehakte Set-Artikel zeigen ihren Anteil am
    // Set-Vorteil der aktuellen Auswahl (gleiche Verteilung wie die Function, auch unter der Mindestzahl als
    // Vorschau), nicht angehakte und Zusatzprodukte ihren eigenen Vorteil max(0, s − g). Kein Vorteil → nur der
    // Gewerbepreis (data-ohne).
    if (b2bEl) {
      const m = Number(b2bEl.dataset.b2bMwst);
      const diff = (f) => Math.round((Number(f.dataset.rabatt || 0) * kurs) / (1 + m)) - (Number(f.dataset.preis) - zahlt(f));
      const anteil = new Map();
      const d = gewaehlt.map(diff);
      const summe = d.reduce((s, x) => s + x, 0);
      const positiv = d.reduce((s, x) => s + Math.max(0, x), 0);
      gewaehlt.forEach((f, i) => anteil.set(f, summe > 0 && positiv > 0 ? Math.min(Math.round((Math.max(0, d[i]) * summe) / positiv), zahlt(f)) : 0));
      karte.querySelectorAll('.custom-sparset__check').forEach((f) => {
        const preise = f.closest('.custom-sparset__zeile')?.querySelector('[data-b2b-preise]');
        if (!preise) return;
        const x = anteil.has(f) ? anteil.get(f) : Math.min(Math.max(0, diff(f)), zahlt(f));
        const setpreis = preise.querySelector('[data-b2b-setpreis]');
        const spar = preise.querySelector('[data-b2b-rabatt]');
        if (setpreis) setpreis.textContent = format(zahlt(f) - x);
        if (spar) spar.textContent = format(x);
        preise.toggleAttribute('data-ohne', !(x > 0));
      });
    }

    // Konfigurator (Set-Seite) und Karte (Übersicht) tragen dieselben
    // data-Merkmale; was eine Fassung nicht hat, wird übersprungen.
    const setzen = (sel, fn) => { const el = karte.querySelector(sel); if (el) fn(el); };
    setzen('[data-summe-einzeln]', (el) => { el.textContent = format(einzeln + zusatzSumme); });
    setzen('[data-summe-set]', (el) => { el.textContent = format(einzeln + zusatzSumme - rabatt); });
    setzen('[data-summe-ersparnis]', (el) => { el.textContent = format(rabatt); });
    setzen('[data-sparset-streich]', (el) => { el.hidden = rabatt === 0; });
    setzen('[data-sparset-ersparnis]', (el) => { el.hidden = rabatt === 0; });
    setzen('[data-sparset-hinweis]', (el) => { el.hidden = rabatt > 0; });
    setzen('[data-sparset-kaufen]', (el) => { el.disabled = !gueltig; });
    return { gewaehlt, zusatz, gueltig, einzeln: einzeln + zusatzSumme, rabatt };
  };

  // Seitliche Reihe: Pfeile blättern um eine Karte, am Anfang/Ende gesperrt.
  // Die Pfeile stehen im Markup auf hidden, damit ohne Skript keine toten
  // Knöpfe dastehen; wischen und scrollen geht auch ohne. Die Übersicht hat
  // zwei Reihen (Werkzeug, Gewerk), jede mit eigenen Pfeilen.
  const reiheEinrichten = (bereich) => {
    const reihe = bereich.querySelector('[data-sparsets-reihe]');
    const steuerung = bereich.querySelector('[data-sparsets-pfeile]');
    if (!reihe || !steuerung || reihe.dataset.bereit) return;
    reihe.dataset.bereit = '1';
    const [zurueck, weiter] = steuerung.querySelectorAll('[data-richtung]');
    const schritt = () => {
      const karte = reihe.querySelector('.custom-sparset-karte');
      return karte ? karte.getBoundingClientRect().width + parseFloat(getComputedStyle(reihe).columnGap || '0') : reihe.clientWidth;
    };
    const pruefen = () => {
      const ende = reihe.scrollWidth - reihe.clientWidth;
      steuerung.hidden = ende <= 2;
      zurueck.disabled = reihe.scrollLeft <= 2;
      weiter.disabled = reihe.scrollLeft >= ende - 2;
    };
    steuerung.addEventListener('click', (e) => {
      const knopf = e.target instanceof Element ? e.target.closest('[data-richtung]') : null;
      if (!knopf) return;
      reihe.scrollBy({ left: Number(knopf.dataset.richtung) * schritt(), behavior: 'smooth' });
    });
    reihe.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen, { passive: true });
    pruefen();

    // Link mit #maurer (alte Links von vor den Set-Seiten): Seite UND Reihe zur Karte bringen.
    const ziel = location.hash && reihe.querySelector(`.custom-sparset-karte[id="${CSS.escape(location.hash.slice(1))}"]`);
    // Senkrecht erst nach dem Laden: Bilder und Hero verschieben die Karte
    // sonst noch, nachdem der Browser zum Anker gesprungen ist.
    if (ziel) {
      reihe.scrollLeft = ziel.offsetLeft - reihe.offsetLeft - parseFloat(getComputedStyle(reihe).scrollPaddingLeft || '0');
      // setTimeout statt requestAnimationFrame: rAF ruht in Hintergrund-Tabs,
      // ein Link aus einer Mail öffnet aber oft genau so.
      const hinScrollen = () => setTimeout(() => {
        window.scrollTo({
          top: ziel.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(ziel).scrollMarginTop) || 0),
          behavior: 'instant', // das Theme setzt scroll-behavior: smooth für die ganze Seite
        });
      }, 0);
      if (document.readyState === 'complete') hinScrollen();
      else window.addEventListener('load', hinScrollen, { once: true });
    }
  };

  // Kopf-Video: erst laden, wenn Bewegung erlaubt ist und kein Datensparmodus
  // an ist (preload="none" im Markup). Schleife vor der Logo-Tafel am Ende.
  const videoEinrichten = (bereich) => {
    const huelle = bereich.querySelector('[data-sparsets-video]');
    const video = huelle && huelle.querySelector('video');
    if (!video || huelle.dataset.bereit) return;
    huelle.dataset.bereit = '1';
    const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sparen = navigator.connection && navigator.connection.saveData;
    if (ruhig || sparen) return; // Standbild (poster) bleibt stehen
    const bis = Number(huelle.dataset.bis) || 0;
    if (bis > 0) {
      video.addEventListener('timeupdate', () => {
        if (video.currentTime >= bis) video.currentTime = 0;
      });
    }
    // video_tag liefert die 1080p-Fassung (7,2 Mbit/s ≈ 43 MB für 48 s). Die
    // kleineren Fassungen liegen daneben und unterscheiden sich nur in diesem
    // Namensteil: Handy 480p (≈ 9 MB), Desktop 720p. Scheitert sie, zurück zum
    // Original.
    const quelle = video.querySelector('source[type="video/mp4"]');
    if (quelle && /HD-1080p-7\.2Mbps/.test(quelle.src)) {
      const original = quelle.src;
      const klein = window.matchMedia('(min-width: 750px)').matches ? 'HD-720p-4.5Mbps' : 'SD-480p-1.5Mbps';
      quelle.src = original.replace('HD-1080p-7.2Mbps', klein);
      quelle.addEventListener('error', () => {
        if (quelle.src === original) return;
        quelle.src = original;
        video.load();
        video.play().catch(() => {});
      }, { once: true });
      video.load();
    }
    video.preload = 'auto';
    const los = video.play();
    if (los && typeof los.catch === 'function') los.catch(() => {});
  };

  // Box-Animation im Kopf: Safari (auch alle Browser auf iPhone/iPad) kann
  // Transparenz nur als HEVC, Chrome/Firefox nur als VP9 — per <source>-Liste
  // nimmt Safari sonst das WebM und zeigt schwarzen Grund. Das Inline-Skript im
  // Markup setzt .is-animiert, wenn Bewegung erlaubt ist. Kommt das Video nicht
  // in 4 s oder scheitert es, bleibt das Standbild.
  const boxEinrichten = (bereich) => {
    const huelle = bereich.querySelector('[data-sparsets-box]');
    const video = huelle && huelle.querySelector('video');
    if (!video || huelle.dataset.bereit) return;
    huelle.dataset.bereit = '1';
    if (!huelle.classList.contains('is-animiert')) return;
    // Im Hintergrund-Tab hält Chrome Videos an — erst starten, wenn sichtbar.
    if (document.hidden) {
      document.addEventListener('visibilitychange', () => {
        delete huelle.dataset.bereit;
        boxEinrichten(bereich);
      }, { once: true });
      return;
    }
    const ua = navigator.userAgent;
    const webkit = /AppleWebKit/.test(ua) && !/Chrome\/|Chromium|Edg\//.test(ua);
    const standbild = () => huelle.classList.remove('is-animiert');
    // Safari/iPhone: das HEVC-Video mit Transparenz blieb trotz Weiterspielen
    // mittendrin stehen (Mathias 19.10.2026, iPhone). Dort stattdessen ein
    // animiertes WebP (720 px, Schleife mit 1,8 s Pause eingebaut): kein Video,
    // kein Zurückspulen per Skript. Bis es geladen ist, bleibt das Standbild.
    if (webkit && huelle.dataset.anim) {
      // Safari entschlüsselt die Einzelbilder erst beim ersten Abspielen, die erste
      // Runde ruckelte (iPhone, 19.10.2026), ab der zweiten lief sie flüssig. Darum
      // läuft die erste Runde fast unsichtbar (Deckkraft 0,01, wird trotzdem gemalt
      // und entschlüsselt) über dem Standbild. Sichtbar wird sie in der Pause am
      // Ende (Box geschlossen, wie das Standbild), danach jede Runde flüssig.
      const bild = huelle.querySelector('img');
      standbild();
      if (!bild) return;
      const anim = document.createElement('img');
      anim.className = bild.className;
      anim.width = bild.width;
      anim.height = bild.height;
      anim.alt = '';
      anim.setAttribute('aria-hidden', 'true');
      anim.style.opacity = '0.01';
      // Box mit PRX-Logo (CTA_BoxMitWerkzeugen.mov, 20.10.2026): 180 Bilder à 33 ms,
      // das letzte steht 1,2 s (geschlossene Box = Standbild). Sichtbar mitten in dieser Pause.
      const zeigenNach = 179 * 33 + 600;
      const zeigen = () => {
        anim.style.opacity = '1';
        bild.style.visibility = 'hidden';
      };
      const starten = () => {
        anim.addEventListener('load', () => {
          requestAnimationFrame(() => setTimeout(zeigen, zeigenNach));
        }, { once: true });
        anim.src = huelle.dataset.anim;
        bild.after(anim);
      };
      const nachLaden = () => {
        if ('requestIdleCallback' in window) requestIdleCallback(starten, { timeout: 1500 });
        else setTimeout(starten, 300);
      };
      const vorab = new Image();
      vorab.onload = () => {
        if (document.readyState === 'complete') nachLaden();
        else window.addEventListener('load', nachLaden, { once: true });
      };
      vorab.src = huelle.dataset.anim;
      return;
    }
    const frist = setTimeout(standbild, 4000);
    video.addEventListener('playing', () => {
      clearTimeout(frist);
      huelle.classList.add('laeuft');
    }, { once: true });
    video.addEventListener('error', standbild, { once: true });

    // Schleife: nach dem Ende Pause auf dem Endbild, dann ab data-schleife
    // weiter. Das Endbild deckt den Sprung ab und blendet aus, sobald das Video
    // wieder läuft. Außer Sicht (weggescrollt, anderer Tab) wartet die nächste
    // Runde, damit kein Video im Hintergrund Strom zieht.
    const ab = Number(huelle.dataset.schleife) || 0;
    const pause = Number(huelle.dataset.pause) || 2500;
    let imBild = true;
    let wartet = false;
    const weiter = () => {
      if (!imBild || document.hidden) {
        wartet = true;
        return;
      }
      wartet = false;
      huelle.classList.add('blende');
      video.addEventListener('seeked', () => {
        const los = video.play();
        if (los && typeof los.catch === 'function') los.catch(() => {});
      }, { once: true });
      video.currentTime = ab;
    };
    video.addEventListener('playing', () => {
      // erst nach dem Zeichnen des neuen Bildes ausblenden
      requestAnimationFrame(() => requestAnimationFrame(() => huelle.classList.remove('blende')));
    });
    video.addEventListener('ended', () => setTimeout(weiter, pause));
    // iPhone hält das Video beim Wegscrollen, Sperren oder App-Wechsel mitten im
    // Lauf an und startet es nicht selbst wieder (Mathias 19.10.2026: Box blieb
    // auf Start- und Übersichtsseite mittendrin stehen). Darum beim Wiederkommen
    // weiterspielen; klappt das nicht, das Standbild zeigen statt eines halben Bilds.
    const fortsetzen = () => {
      if (!imBild || document.hidden || wartet) return;
      if (!video.paused || video.ended || !huelle.classList.contains('is-animiert')) return;
      const nochmal = video.play();
      if (nochmal && typeof nochmal.catch === 'function') nochmal.catch(standbild);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([eintrag]) => {
        imBild = eintrag.isIntersecting;
        if (imBild && wartet) weiter();
        else fortsetzen();
      }).observe(huelle);
    }
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && wartet) weiter();
      else fortsetzen();
    });
    window.addEventListener('pageshow', fortsetzen);
    // Angehalten, obwohl sichtbar (Stromsparmodus, Ladeabbruch): kurz warten, dann neu versuchen.
    video.addEventListener('pause', () => {
      if (!video.ended) setTimeout(fortsetzen, 400);
    });

    video.src = webkit ? huelle.dataset.mov : huelle.dataset.webm;
    video.preload = 'auto';
    const los = video.play();
    if (los && typeof los.catch === 'function') los.catch(standbild);
  };

  // Kauf-Leiste unten auf der Set-Seite (nur Handy/Tablet, CSS blendet sie ab
  // 990 px aus): sichtbar, sobald der Knopf im Konfigurator nach oben
  // weggescrollt ist. Inhalt und Sperre spiegeln den Konfigurator.
  const leisteEinrichten = (bereich) => {
    const leiste = bereich.querySelector('[data-sparset-leiste]');
    const karte = bereich.querySelector('.custom-sparset-seite__kasse [data-sparset]');
    const fuss = karte && karte.querySelector('.custom-sparset__fuss');
    const knopf = karte && karte.querySelector('[data-sparset-kaufen]');
    if (!leiste || !fuss || !knopf || leiste.dataset.bereit) return;
    leiste.dataset.bereit = '1';
    const lKnopf = leiste.querySelector('[data-leiste-knopf]');
    const abgleichen = () => {
      const preis = karte.querySelector('[data-summe-set]');
      const spar = karte.querySelector('[data-sparset-ersparnis]');
      const betrag = karte.querySelector('[data-summe-ersparnis]');
      if (preis) leiste.querySelector('[data-leiste-preis]').textContent = preis.textContent;
      if (spar) leiste.querySelector('[data-leiste-spar]').hidden = spar.hidden;
      if (betrag) leiste.querySelector('[data-leiste-ersparnis]').textContent = betrag.textContent;
      lKnopf.disabled = knopf.disabled;
      lKnopf.textContent = knopf.textContent.trim();
    };
    abgleichen();
    new MutationObserver(abgleichen).observe(fuss, { subtree: true, childList: true, characterData: true, attributes: true });
    lKnopf.addEventListener('click', () => knopf.click());
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([eintrag]) => {
        leiste.hidden = eintrag.isIntersecting || eintrag.boundingClientRect.top > 0;
      }).observe(fuss);
    }
  };

  const starten = (wurzel = document) => {
    wurzel.querySelectorAll('[data-custom-sparsets]').forEach(videoEinrichten);
    wurzel.querySelectorAll('[data-custom-sparsets]').forEach(boxEinrichten);
    wurzel.querySelectorAll('[data-custom-sparsets]').forEach(leisteEinrichten);
    wurzel.querySelectorAll('[data-sparsets-rail]').forEach(reiheEinrichten);
    // Liquid rendert Rabatte in Shopwährung; in Fremdwährung umschreiben
    // (Badges, Konfigurator, Erklärungen). Einmal je Element.
    if (kurs !== 1) {
      wurzel.querySelectorAll('[data-geld][data-shopwaehrung="true"]:not([data-umgerechnet])').forEach((el) => {
        el.textContent = format(umrechnen(Number(el.dataset.geld)));
        el.dataset.umgerechnet = '1';
      });
    }
    // Der Browser stellt beim Zurückblättern die Auswahlliste wieder her, die
    // Checkbox-Daten aber nicht — darum einmal abgleichen.
    wurzel.querySelectorAll('[data-sparset-wahl]').forEach(wahlUebernehmen);
    wurzel.querySelectorAll('[data-sparset]').forEach(rechnen);
    wurzel.querySelectorAll('[data-sparset-umschalten]').forEach((knopf) => {
      const feld = document.getElementById(knopf.dataset.sparsetUmschalten);
      if (!feld || feld.disabled) return;
      knopfAbgleichen(feld);
      knopf.hidden = false;
    });
  };

  // Knopf in der Produkt-Erklärung (Set-Seite) = zweiter Schalter für das
  // Häkchen im Konfigurator. Der Zustand steht nur in der Checkbox; der
  // Knopf zeigt ihn an („✓ Im Set" / „Zum Set hinzufügen").
  const knopfAbgleichen = (feld) => {
    document.querySelectorAll(`[data-sparset-umschalten="${CSS.escape(feld.id)}"]`).forEach((knopf) => {
      knopf.dataset.gewaehlt = feld.checked ? 'ja' : 'nein';
    });
  };

  document.addEventListener('click', (e) => {
    const knopf = e.target instanceof Element ? e.target.closest('[data-sparset-umschalten]') : null;
    if (!knopf) return;
    const feld = document.getElementById(knopf.dataset.sparsetUmschalten);
    if (!feld || feld.disabled) return;
    feld.click(); // löst change aus: nachrechnen und Knopf abgleichen
  });

  // Wahlgruppe (Handschuhgröße, Blattpackung): Die Auswahlliste schreibt die
  // gewählte Variante samt Preis und Rabatt auf die Checkbox der Zeile — die
  // Checkbox bleibt die einzige Quelle für Rechnung und Warenkorb.
  const wahlUebernehmen = (liste) => {
    const feld = document.getElementById(liste.dataset.sparsetWahl);
    const option = liste.selectedOptions[0];
    if (!feld || !option) return;
    feld.dataset.variante = option.value;
    feld.dataset.preis = option.dataset.preis;
    feld.dataset.rabatt = option.dataset.rabatt;
    feld.dataset.sku = option.dataset.sku;
    // Gewerbekunden: Gewerbepreis der Option mitnehmen und anzeigen
    if (option.dataset.gewerbe !== undefined) feld.dataset.gewerbe = option.dataset.gewerbe;
    const zeile = liste.closest('.custom-sparset__zeile');
    if (zeile) {
      const name = zeile.querySelector('[data-wahl-name]');
      if (name && option.dataset.name) name.textContent = option.dataset.name;
      const preis = zeile.querySelector('[data-wahl-preis]');
      if (preis) preis.textContent = format(Number(option.dataset.gewerbe ?? option.dataset.preis));
      const rabatt = zeile.querySelector('[data-wahl-rabatt]');
      if (rabatt) rabatt.textContent = format(umrechnen(Number(option.dataset.rabatt)));
      // Preis im Set (Normalpreis durchgestrichen); ohne Rabatt nur der Preis (wie im Liquid der Zeile)
      const setpreis = zeile.querySelector('[data-wahl-setpreis]');
      if (setpreis) setpreis.textContent = format(Math.max(0, Number(option.dataset.preis) - umrechnen(Number(option.dataset.rabatt || 0))));
      const teil = zeile.querySelector('[data-wahl-imset]');
      // Gewerbekunden: die Zeile füllt rechnen() (Vorteil hängt an der ganzen Auswahl)
      if (teil && !teil.hasAttribute('data-b2b-preise')) teil.toggleAttribute('data-ohne', !(Number(option.dataset.rabatt) > 0));
      const bild = zeile.querySelector('.custom-sparset__bild img');
      if (bild && option.dataset.bild) {
        bild.removeAttribute('srcset');
        bild.src = option.dataset.bild;
      }
    }
    const karte = feld.closest('[data-sparset]');
    if (karte) rechnen(karte);
  };

  document.addEventListener('change', (e) => {
    if (e.target instanceof HTMLSelectElement && e.target.matches('[data-sparset-wahl]')) wahlUebernehmen(e.target);
  });

  document.addEventListener('change', (e) => {
    const feld = e.target;
    if (!(feld instanceof HTMLInputElement) || !feld.matches('.custom-sparset__check')) return;
    const karte = feld.closest('[data-sparset]');
    if (karte) rechnen(karte);
    knopfAbgleichen(feld);
  });

  document.addEventListener('click', async (e) => {
    const knopf = e.target instanceof Element ? e.target.closest('[data-sparset-kaufen]') : null;
    if (!knopf || knopf.disabled) return;
    const karte = knopf.closest('[data-sparset]');
    if (!karte) return;

    const { gewaehlt, zusatz, gueltig, einzeln, rabatt } = rechnen(karte);
    if (!gueltig) return;

    const setId = karte.dataset.sparset;
    const alle = karte.querySelectorAll(`${SET_FELD}:not(:disabled), ${SET_FELD}[data-pflicht]:checked`).length;

    if (typeof window.preschTrack === 'function') {
      window.preschTrack('sparset_add', {
        sparset: setId,
        quelle: karte.dataset.quelle || 'set-seite', // Übersicht oder Set-Seite
        artikel_gewaehlt: gewaehlt.length,
        artikel_abgewaehlt: alle - gewaehlt.length,
        abgewaehlt_skus: [...karte.querySelectorAll(`${SET_FELD}:not(:checked):not(:disabled)`)]
          .map((f) => f.dataset.sku).join(','),
        zusatz_skus: zusatz.map((f) => f.dataset.sku).join(','),
        wert_eur: (einzeln - rabatt) / 100 / kurs,
      });
    }

    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');
    const update = window.Shopify?.actions?.updateCart;
    try {
      if (typeof update === 'function') {
        await update({
          action: 'add',
          lines: [
            ...gewaehlt.map((f) => ({
              merchandiseId: Number(f.dataset.variante),
              quantity: 1,
              attributes: [{ key: '_Sparset', value: setId }],
            })),
            // Eigener Schlüssel: zählt nicht zur Mindestzahl, eigener Zusatz-Rabatt.
            ...zusatz.map((f) => ({
              merchandiseId: Number(f.dataset.variante),
              quantity: 1,
              attributes: [{ key: '_Sparset_Zusatz', value: setId }],
            })),
          ],
        });
        const schublade = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
        if (schublade && typeof schublade.open === 'function') schublade.open();
      } else {
        const antwort = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              ...gewaehlt.map((f) => ({ id: Number(f.dataset.variante), quantity: 1, properties: { _Sparset: setId } })),
              ...zusatz.map((f) => ({ id: Number(f.dataset.variante), quantity: 1, properties: { _Sparset_Zusatz: setId } })),
            ],
          }),
        });
        if (!antwort.ok) throw new Error(String(antwort.status));
        window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
        return;
      }
    } catch {
      /* Knopf wieder freigeben statt still kaputt */
    }
    knopf.removeAttribute('aria-busy');
    rechnen(karte);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => starten(), { once: true });
  } else {
    starten();
  }
  document.addEventListener('shopify:section:load', (e) => starten(e.target));
})();
